<template>
  <div class="sociallogin">
    <div slot="content" class="content">
      <div class="content__header">
        <div class="content__header--title">
          <h2 class="small-title title" v-if="!checkAll(this.data.provider)">You already created an account using <span v-if="checkGoogle(this.data.provider)">Google</span> <span v-if="checkFacebook(this.data.provider)">Facebook</span>.</h2>
          <h2 class="small-title title" v-else>You already created an account using <span>Google</span> and <span>Facebook</span>.</h2>
          <h2 class="small-title subtitle">Please log in instead.</h2>
        </div>
      </div>
      <div class="content__mediasocial">
        <div class="img-profile">
          <img class="img-circle" :src="this.profile.avatar || '/img/account/img-ava.png'" alt="">
        </div>
        <div class="info-profile">
          <h2 class="regular-font name">{{this.profile.name}}</h2>
          <p class="small-font email">{{this.profile.email}}</p>
        </div>
        <button v-if="checkFacebook(this.data.provider)" class="btn-block not-rounded facebook" @click="socialLogin(`facebook`, currentRoute)">
          <i class="adx-ic_facebook"></i>
          Sign in with Faceboook
        </button>
        <button v-if="checkGoogle(this.data.provider)" class="btn-block not-rounded secondary google" @click="socialLogin(`google`, currentRoute)">
          <i class="adx-ic_google"></i>
          Sign in with Google
        </button>
      </div>
      <div class="content__fulldivider">
      </div>
      <div class="content__footer">
        <div class="signup">
          <span @click.stop="goToSignIn">Login with a different account</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import { authMixin } from '@/lib/mixins/authMixin'

export default {
  name: 'adx-social-page',
  components: {
    'adx-modal': Modal,
  },
  mixins: [ authMixin ],
  props: {
    data: {
      required: false
    }
  },
  data() {
    return {
      profile: undefined
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.profile = this.$route.query
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    goToSignIn() {
      this.$router.push({name: 'signin'})
    },
    checkFacebook(value) {
      return value.includes('facebook')
    },
    checkGoogle(value) {
      return value.includes('google-oauth2')
    },
    checkAll(value) {
      return this.checkFacebook(value) && this.checkGoogle(value)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>